/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { AdminApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICourseForAdmin } from '../CoursesSlice';
import { ISectionForAdmin } from '.';

export type TCreateNewCourseSectionAsAdmin = {
  sortingKey: number;
  course: string;
  title?: string;
  description?: string;
  parent?: string;
  type: ISectionForAdmin['type'];
  dateTime?: string;
  duration?: number;
};

export type TUpdateCourseSectionAsAdmin = {
  _id: string;
  course: string;
  sortingKey?: number;
  title?: string;
  description?: string;
  dateTime?: string;
  duration?: number;
  startDate?: string;
  endDate?: string;
};

const apiDataProvider = new APIDataProvider();

export const getAdminCourseSectionsByCourseId = createAsyncThunk(
  '/admin/courses/id/sections',
  async (id: string) => {
    const path = `${AdminApiPaths.courses}/${id}`;
    const response = await apiDataProvider.get<TApiResponse<ICourseForAdmin>>(
      path
    );

    return response.data;
  }
);

export const deleteCourseSectionByIdAsAdmin = createAsyncThunk(
  '/admin/sections/deleteOne',
  async (id: string) => {
    const path = `${AdminApiPaths.sections}/${id}`;
    const response = await apiDataProvider.delete<
      TApiResponse<ISectionForAdmin>
    >(path);

    return response.data;
  }
);

export const createNewCourseSectionAsAdmin = createAsyncThunk(
  '/admin/sections/create',
  async (data: TCreateNewCourseSectionAsAdmin) => {
    const path = `${AdminApiPaths.sections}`;
    const response = await apiDataProvider.post<TApiResponse<ISectionForAdmin>>(
      path,
      data
    );

    return response.data;
  }
);
